// Zonamento brand switch (DESIGN.md, BRAND.md; plan mid-v6k8). Build time only:
// the Dockerfile maps NEW_BRAND_ENABLED to REACT_APP_NEW_BRAND, which CRA inlines,
// and scripts/brand/stamp_html.mjs stamps the same head into every built HTML file.
import BRAND_HEAD from "@/lib/brandHead.json";

export const NEW_BRAND = ["1", "true", "yes", "on"].includes((process.env.REACT_APP_NEW_BRAND || "").trim().toLowerCase());

// Day palette from the DESIGN.md frontmatter. For consumers that cannot read CSS
// variables (canvas, canvas-confetti, chart SVG attributes, Leaflet options, <meta>).
export const BRAND_HEX = {
  primary: "#1F2E4D",
  "on-primary": "#FFFFFF",
  "habitacao-yellow": "#F6D55C",
  "equipamentos-red": "#E05A47",
  "espacos-verdes-green": "#7FBF6A",
  "equipamentos-tint": "#F4B8A8",
  signal: "#C7322B",
  "on-signal": "#FFFFFF",
  "signal-text": "#B92E28",
  link: "#1F4E8C",
  "good-text": "#2F6B2A",
  ink: "#1A1A1A",
  muted: "#555550",
  paper: "#FFFFFF",
  surface: "#FFFFFF",
  "surface-2": "#F3F3F0",
  line: "#D6D6D0",
  "line-strong": "#C3C3C3",
  "map-land": "#F3F3F0",
  "map-water": "#B9D7EA",
  "map-park": "#A8D59A",
  "map-road": "#FFFFFF",
  "map-major": "#D9D9D3",
};

// Night values for the MapLibre base map, which cannot read CSS variables: the same hexes
// brand_zonamento.css declares under [data-theme="dark"] (test_zoning_style checks they match).
export const BRAND_HEX_NIGHT = {
  ink: "#EEF0F2",
  "map-land": "#16191E",
  "map-water": "#1A2D40",
  "map-park": "#23402A",
  "map-road": "#2A2F37",
  "map-major": "#323740",
};

/** Concrete hex for a brand role: the Zonamento value when the switch is on, oldHex otherwise. */
export function brandColor(role, oldHex) {
  if (!NEW_BRAND) return oldHex;
  if (!(role in BRAND_HEX)) throw new Error(`brandColor: unknown role ${role}`);
  return BRAND_HEX[role];
}

/** Stamps <html data-brand="zonamento">, icons, manifest, theme-color and fonts.
 * No-op when the switch is off or the built HTML is already stamped. */
export function applyBrandToDocument(doc = document) {
  const html = doc.documentElement;
  if (!NEW_BRAND || html.hasAttribute("data-brand")) return;
  html.setAttribute("data-brand", "zonamento");
  doc.head.querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"], link[rel="manifest"]').forEach((node) => node.remove());
  const link = (attributes) => {
    const node = doc.createElement("link");
    Object.entries(attributes).forEach(([name, value]) => node.setAttribute(name, value));
    doc.head.appendChild(node);
  };
  BRAND_HEAD.icons.forEach(link);
  link({ rel: "manifest", href: BRAND_HEAD.manifest });
  link({ rel: "stylesheet", href: BRAND_HEAD.fontsHref });
  let theme = doc.head.querySelector('meta[name="theme-color"]');
  if (!theme) {
    theme = doc.createElement("meta");
    theme.setAttribute("name", "theme-color");
    doc.head.appendChild(theme);
  }
  theme.setAttribute("content", BRAND_HEAD.themeColor);
}
